import React, {memo} from "react";
import {formikPropertyChanged} from "./index";
import {useTranslation} from "react-i18next";
import FormSection from "../../../../components/FormSection";
import Grid from "@mui/material/Grid";
import IncidentField from "./IncidentField";
import IncidentSelect from "./IncidentSelect";
import FormSubSectionTitle from "./FormSubSectionTitle";
import GridItemOffset from "./GridItemOffset";
import {FieldWithTooltip} from "./FormTooltip";

const attributes = [
    'snowHeightMin', 'snowHeightMax', 'slopeAngleRelease', 'avalancheType', 'avalancheSizeV1',
    'daysSinceLastSnowfall', 'ww', 'nearRidge', 'dangerScaleBulletin', 'dangerScalePre93'
]

const Conditions = memo(({formik, incidentRegistry, inputDisabled}) => {
    const {t} = useTranslation(['incidents', 'enums']);
    const avalancheTypeRegistry = incidentRegistry.data?.avalancheType ?? [];
    const avalancheSizeRegistry = incidentRegistry.data?.avalancheSizeV1 ?? [];
    const wwRegistry = incidentRegistry.data?.ww ?? [];
    const nearRidgeRegistry = incidentRegistry.data?.nearRidge ?? [];
    const dangerScaleBulletinRegistry = incidentRegistry.data?.dangerScale ?? [];
    const dangerScalePre93Registry = incidentRegistry.data?.dangerScale93 ?? [];

    return <FormSection title={t('incidentForm.conditionsTitle')}
                        error={attributes.some(attr => Boolean(formik.errors[attr]) && formik.touched[attr])}>
        <Grid container rowSpacing={3} columnSpacing={4}>
            <Grid item xs={12} md={4}>
                <FormSubSectionTitle title={t('incidentForm.condition.snowHeight')}/>
            </Grid>
            <Grid item xs={12} md={4}>
                <IncidentField formik={formik}
                               name="snowHeightMin"
                               type="number"
                               unitOfMeasure="m"
                               disabled={inputDisabled}/>
            </Grid>
            <Grid item xs={12} md={4}>
                <FieldWithTooltip message={t('incidentForm.tooltip.snowHeightMax')}>
                    <IncidentField formik={formik}
                                   name="snowHeightMax"
                                   type="number"
                                   unitOfMeasure="m"
                                   disabled={inputDisabled}/>
                </FieldWithTooltip>
            </Grid>

            <Grid item xs={12} md={4}>
                <FormSubSectionTitle title={t('incidentForm.condition.slopeAngleRelease')}/>
            </Grid>
            <Grid item xs={12} md={4}>
                <FieldWithTooltip message={t('incidentForm.tooltip.slopeAngleRelease')}>
                    <IncidentField formik={formik}
                                   name="slopeAngleRelease"
                                   type="number"
                                   unitOfMeasure="°"
                                   disabled={inputDisabled}/>
                </FieldWithTooltip>
            </Grid>
            <GridItemOffset xs={12} md={4}/>

            <Grid item xs={12} md={4}>
                <FormSubSectionTitle title={t('incidentForm.condition.avalancheData')}/>
            </Grid>
            <Grid item xs={12} md={4}>
                <IncidentSelect formik={formik}
                                name="avalancheType"
                                registry={avalancheTypeRegistry}
                                disabled={inputDisabled}/>
            </Grid>
            <Grid item xs={12} md={4}>
                <IncidentSelect formik={formik}
                                name="avalancheSizeV1"
                                registry={avalancheSizeRegistry}
                                disabled={inputDisabled}/>
            </Grid>

            <Grid item xs={12} md={4}>
                <FormSubSectionTitle title={t('incidentForm.condition.meteo')}/>
            </Grid>
            <Grid item xs={12} md={4}>
                <FieldWithTooltip message={t('incidentForm.tooltip.daysSinceLastSnowfall')}>
                    <IncidentField formik={formik}
                                   name="daysSinceLastSnowfall"
                                   type="number"
                                   disabled={inputDisabled}/>
                </FieldWithTooltip>
            </Grid>
            <Grid item xs={12} md={4}>
                <IncidentSelect formik={formik}
                                name="ww"
                                registry={wwRegistry}
                                disabled={inputDisabled}/>
            </Grid>


            <Grid item xs={12} md={4}>
                <FormSubSectionTitle title={t('incidentForm.condition.nearRidge')}/>
            </Grid>
            <Grid item xs={12} md={4}>
                <IncidentSelect formik={formik}
                                name="nearRidge"
                                registry={nearRidgeRegistry}
                                disabled={inputDisabled}/>
            </Grid>
            <GridItemOffset xs={12} md={4}/>

            <Grid item xs={12} md={4}>
                <FormSubSectionTitle title={t('incidentForm.condition.dangerScaleBulletin')}/>
            </Grid>
            <Grid item xs={12} md={4}>
                <FieldWithTooltip message={t('incidentForm.tooltip.dangerScaleBulletin')}>
                    <IncidentSelect formik={formik}
                                    name="dangerScaleBulletin"
                                    registry={dangerScaleBulletinRegistry}
                                    disabled={inputDisabled}/>
                </FieldWithTooltip>
            </Grid>
            <Grid item xs={12} md={4}>
                <IncidentSelect formik={formik}
                                name="dangerScalePre93"
                                registry={dangerScalePre93Registry}
                                disabled={inputDisabled}/>
            </Grid>
        </Grid>
    </FormSection>

}, (prevProps, nextProps) => formikPropertyChanged(prevProps, nextProps, attributes))


export default Conditions;